import { styled } from '@material-ui/core';

const ChatMessageContactBtn = styled('button')(({ theme }) => ({
  border: 0,
  padding: 6,
  flexBasis: 150,
  fontSize: '.9rem',
  color: '#478ECC',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  backgroundColor: theme.palette.type === 'dark' ? 'transparent' : '#fff',
  borderTop:
    theme.palette.type === 'dark'
      ? '1px solid rgba(255,255,255,0.08)'
      : '1px solid #e6e6e6',
  '&:hover': {
    textDecoration: 'underline',
    fontWeight: '500',
  },
}));

export default ChatMessageContactBtn;
